import CustodianBasicDetails from './CustodianBasicDetails';
import CustodianContactInfo from './CustodianContactInfo';
import FacilityNotesInfo from './FacilityNotesInfo';
import MailingAddress from './MailingAddress';
import MappedIds from './MappedIds';
import Panel from '../../../components/UI/Panel';

export default function CustodianMainInfo({
  formik,
  custodianTypes,
  states,
  phoneTypes,
  portalTypes,
  sourceTypes,
  timeZones,
  isFacility,
  setIsFacility,
  isCustodian,
  setIsCustodian,
  copyCustodianAddress
}: Readonly<{
  formik: any;
  custodianTypes: any[];
  states: any[];
  phoneTypes: any[];
  portalTypes: any[];
  sourceTypes: any[];
  timeZones: any[];
  isFacility: boolean;
  setIsFacility: (val: boolean) => void;
  isCustodian: boolean;
  setIsCustodian: (val: boolean) => void;
  copyCustodianAddress: any
}>) {
  return (
    <>
      <CustodianBasicDetails
        custodianTypes={custodianTypes}
        phoneTypes={phoneTypes}
        portalTypes={portalTypes}
        formik={formik}
        isFacility={isFacility}
        setIsFacility={setIsFacility}
        isCustodian={isCustodian}
        timeZones={timeZones}
        states={states}
        setIsCustodian={setIsCustodian}
      />

      {isCustodian &&
        <MailingAddress states={states}
          timeZones={timeZones}
          formik={formik}
          copyMainAddress={copyCustodianAddress}
        />}

      <CustodianContactInfo formik={formik} />

      <Panel headerText="Source Ids">
        <MappedIds sourceTypes={sourceTypes} formik={formik} />
      </Panel>

      <FacilityNotesInfo formik={formik} />

    </>
  );
}
